module.exports = __webpack_public_path__ + "static/media/new.cdd80a8e.svg";